























































































































import { Component, Vue, Watch } from "vue-property-decorator";
import FaqSection from "../components/FaqSection.vue";
@Component({
  components: {
    FaqSection,
  },
})
export default class Faq extends Vue {
  @Watch("windowWidth")
  onPropertyChanged(value: string, oldValue: string) {
    if (this.windowWidth < 576) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }
  get faq() {
    return this.$store.getters.faq;
  }

  faqTypes = ["for-consumers", "for-brands", "for-brand-owners-customers"];

  consumers = [];
  brands = [];
  brandOwners = [];
  faqLoaded = false;
  isMobile = false;
  windowWidth = window.innerWidth;

  created() {
    window.innerWidth < 576 ? (this.isMobile = true) : (this.isMobile = false);
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
  }

  async mounted() {
    this.faqLoaded = false;
    await this.$store.dispatch("getFAQ");
    this.initializeFAQ();
    this.faqLoaded = true;
  }

  initializeFAQ() {
    this.brandOwners = this.faq.filter(
      (x: { faqType: string }) => x.faqType === "for-brand-owners-customers"
    );
    this.consumers = this.faq.filter(
      (x: { faqType: string }) => x.faqType === "for-consumers"
    );
    this.brands = this.faq.filter(
      (x: { faqType: string }) => x.faqType === "for-brands"
    );
  }
}
